import { HamburgerMenuContext } from '@components/organisms/navbar/HamburgerMenuContext';
import { cn } from '@moreharvest/component-library';
import { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router';

interface NavLinksBaseProps {
    leftIcon?: React.ReactNode;
    label: string;
    to: string;
    id?: string;
    cy?: string;
    onClick?: () => void;
}

const listItemClasses = cn(
    'max-w-[360px] w-full lg:w-fit flex gap-x-4 lg:hover:underline'
);

const NavLinksBase = ({
    leftIcon,
    label,
    to,
    id,
    cy,
    onClick,
}: NavLinksBaseProps) => {
    const { setIsOpen } = useContext(HamburgerMenuContext);
    const navigate = useNavigate();
    return (
        <li className={cn(listItemClasses, 'Label-Large p-1 items-center')}>
            {leftIcon && <div className="lg:hidden">{leftIcon}</div>}
            {to.startsWith('http') ? (
                <a
                    href={to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-neutral-600 dark:text-neutral-600-dark focus:border-1 focus:border-blue-400"
                    id={id}
                    data-cy={cy}
                    onClick={onClick}
                >
                    {label}
                </a>
            ) : (
                <NavLink
                    to={to}
                    onClick={e => {
                        e.preventDefault();
                        setIsOpen(false);
                        navigate(to);
                        onClick?.();
                    }}
                    className={({ isActive }) =>
                        isActive
                            ? 'text-neutral-950 dark:text-neutral-950-dark font-semibold lg:bg-transparent bg-amber-100 rounded lg:rounded-none focus:border-1 focus:border-blue-400'
                            : 'text-neutral-600 dark:text-neutral-600-dark focus:border-1 focus:border-blue-400'
                    }
                    id={id}
                    data-cy={cy}
                >
                    {label}
                </NavLink>
            )}
        </li>
    );
};

export default NavLinksBase;
